var map = {
	"./ar/photo/PhotoPage.vue": [
		5041,
		41
	],
	"./en/photo/PhotoPage.vue": [
		3283,
		283
	],
	"./fa/photo/PhotoPage.vue": [
		5942,
		942
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8042;
module.exports = webpackAsyncContext;